module.exports = __webpack_public_path__ + "static/media/Quilladin_gaussian2.645037b4.png";